export default "__VITE_ASSET__l_M_V5wZ__"